<template>
  <v-layout
    row
    class="mb-4"
  >
    <v-flex
      xs12
      sm8
      offset-sm2
      lg6
      offset-lg3
      class="mt-5"
      v-if="anfrage"
    >
      <v-card class="mx-1">
        <v-card-title
          primary-title
          class="grey lighten-4"
          v-if="anfrage.landingbezug"
        >
      
          <h3 class="headline mb-0">Anfrage im Thema {{ anfrage.landingbezug.name }} in {{ anfrage.stadtbezug.name }} </h3>
          
          <v-spacer></v-spacer>
            {{ anfrage.userscount }} <v-icon right>remove_red_eye</v-icon> 
       </v-card-title>
        <v-card-title
          primary-title
          class="grey lighten-4"
          v-else
        >
           <h3 class="headline mb-0">Direkte Anfrage an {{ BetriebsName }}</h3>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text>

          <v-layout
            row
            wrap
          >
            <v-flex
              xs12
              mb-2
            >
              <v-icon left>timelapse</v-icon>
              <span class="subheading">
                Freigeschaltet: <strong>
                  <timeago :datetime="anfrage.updated_at"></timeago>
                </strong>,
                erstellt <timeago :datetime="anfrage.created_at"></timeago>
              </span>
            </v-flex>
            <v-flex
              xs12
              my-2
            >
              <span v-if="anfrage.landingbezug">
              <v-icon left>category</v-icon>
              <span class="subheading">
                Thema: <strong>{{ anfrage.landingbezug.name }}</strong>
              </span>
              </span>
            </v-flex>

            <v-flex
              xs12
              my-2
              v-if="anfrage.landingbezug"
            >
              <v-icon left>location_on</v-icon>
              <span class="subheading">
                Gebiet: <strong>{{ anfrage.stadtbezug.name }}</strong>
              </span>
            </v-flex>

            <v-flex
              xs12
              my-2
            >
              <v-icon left>message</v-icon>
              <span class="subheading" v-if="anfrage.landingbezug">
                Der Interessent wählte folgende Leistungen::
              </span>
              <span v-else class="subheading">
                Nachricht:
              </span>
            </v-flex>
            <v-flex
              xs12
              class="mt-1 mb-3 pa-3 subheading grey lighten-5"
              style="white-space: pre;"          
            >
              <span v-if="anfrage.landingbezug">{{ anfrage.text | pretty }}</span>
              <span v-else>{{ anfrage.text }}</span>
            </v-flex>
          </v-layout>
          <anfragen-kontakt :key="anfrage.id" :anfrage="anfrage"></anfragen-kontakt>

          <div v-if="!landingbezug">
            <anfragen-antwort :anfrage="anfrage"></anfragen-antwort>
          </div>

        </v-card-text>
      </v-card>
       <vue-json-pretty :data="anfrage">
    </vue-json-pretty>
    </v-flex>

    <!-- <v-btn @click="getMeinBetrieb()">recheck</v-btn> -->

  </v-layout>
  
</template>

<script>
import axios from 'axios'
import AnfragenKontakt from '~/components/anfragen/AnfragenKontakt.vue'
import AnfragenAntwort from '~/components/anfragen/AnfragenAntwort.vue'

export default {
  components: {
    AnfragenKontakt,
    AnfragenAntwort
  },
  data () {
    return {
      showcontact: false,
      anfrage: '',
      busy: false
    }
  },
  filters: {
    pretty: function (value) {
      return JSON.stringify(JSON.parse(value), null, 2)
    }
  },
  created () {
    // this.getAnfrage()
    // this.getMeineLeistungen()
  },
  mounted () {},
  computed: {
    BetriebsName: function () {
      if (this.$store.getters.authBetrieb) {
        if (this.$store.getters.authBetrieb.Vollername) {
          return this.$store.getters.authBetrieb.Vollername
        }
      } else {
        return 'Name'
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    axios
      .get('/api/v1/anfrage/' + to.params.id)
      .then(resp => {
        next(vm => {
          vm.anfrage = resp.data
          // console.log(resp.data)
        })
      })
      .catch(error => {
        console.log(error)
        //  app.$router.push('/')
        next({ name: '404' })
        // next('/404')
        // next({ name: '404' })
      })
  },
  beforeRouteUpdate (to, from, next) {
    axios
      .get('/api/v1/anfrage/' + to.params.id)
      .then(resp => {
        this.setData(resp.data)
        // app.anzeige = resp.data
        next()
        // next(vm => (vm.anzeige = resp.data))
      })
      .catch(error => {
        console.log(error)

        //  app.$router.push('/')
        next({ name: '404' })
      })
  },
  methods: {
    getAnfrage: function () {
      const app = this
      axios
        .get('/api/v1/anfrage')
        .then(function (resp) {
          app.anfrage = resp.data
          console.log(resp)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    zeigeKontakt: function () {
      var id = this.anfrage.hashid
      axios
        .post('/api/v1/anfragekontakt/' + id)
        .then(function (resp) {
          console.log(resp)
          this.showcontact = true
        })
        .catch(function (error) {
          console.log(error)
        })
      this.showcontact = true
    },
    setData (data) {
      this.anfrage = data
    },
    TrueTransform: function (value) {
      if (value === true) {
        return 'gewünscht'
      } else {
        return value
      }
    }
  },
  metaInfo () {
    if (this.anfrage) {
      if (this.anfrage.landingbezug) {
        return {
          title:
          'Anfrage in ' +
          this.anfrage.landingbezug.name +
          ' in ' +
          this.anfrage.stadtbezug.name
        }
      } else {
        return 'Direktanfrage'
      }
    }
  }
}
</script>

